module.exports = __webpack_public_path__ + "static/img/introduce-img3.05cd8488.png";